import { Skeleton } from "@particles/index"

import useListItem from "@molecules/ListItem/ListItem.context"

import styles from "./ListItemAvatarAndContent.module.scss"
import { ListItemAvatarAndContentProps } from "./ListItemAvatarAndContent.types"

export default function ListItemAvatarAndContent(props: ListItemAvatarAndContentProps) {
    const { avatar, content } = props

    const { isLoading } = useListItem()

    const resolvedAvatar = isLoading && avatar ? <Skeleton height={36} width={36} borderRadius={6} /> : avatar

    return (
        <div className={styles.base}>
            {resolvedAvatar && <div className={styles.avatarSlot}>{resolvedAvatar}</div>}
            <div className={styles.contentSlot}>{content}</div>
        </div>
    )
}
